module.exports = "### FaxJS\n\n- Jordan Walke side project\n- Fix shortcomings of BoltJS\n- Functional APIs\n- Discourage mutation\n\n- Incorporated ideas from XHP\n  - Understanding of markup and content\n  - Eliminating need for manual string concatenation\n  - Reducing risk of XSS\n\nMarch 2012\n- FaxJS brought into Facebook codebase\n- Renamed FBolt\n- Needed better standalone name\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/notes_6.md
// module id = 1487
// module chunks = 0